const ACRONYMS = new Set(["CSV", "PDF", "QR", "ID", "URL", "IBAN", "OIB", "VAT"]);

// "PendingPayment", "pending-payment", "pending payment" -> "PENDING_PAYMENT"
export const normalizeEnumKey = (value?: string | null) => (value ?? "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[-\s]+/g, "_")
    .toUpperCase();

// "BANK_TRANSFER" / "BankTransfer" -> "Bank Transfer". Prefer a translation key; use this as its defaultValue.
export const humanizeEnumValue = (value?: string | null, emptyValue = "-") => {
    if (!value) {
        return emptyValue;
    }

    return value
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/[_-]+/g, " ")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(part => ACRONYMS.has(part.toLocaleUpperCase())
            ? part.toLocaleUpperCase()
            : `${part.charAt(0).toLocaleUpperCase()}${part.slice(1).toLocaleLowerCase()}`)
        .join(" ");
};
